import React from 'react';
import './Styles.scss';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import {Button as SementicBtn, Button, Form, Label, List, Input, Dropdown} from "semantic-ui-react";
import TxtAreaLbl from "../../../../components/Input/TextArea/TextAreaLbl";
import {Checkbox, DatePicker, TimePicker, Tooltip} from 'antd';
import Lbl from "../../../../components/Label/Lbl";
import * as common from "../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import axios_eventtag from "../../../../axios/axios_eventtag";
import apiConfig from "../../../../axios/axios_api_services";
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import LabelDropdown from "../../../../components/Dropdown/LabelDropdown/LabelDropdown";
const {RangePicker} = DatePicker;

// function disabledDate(current) {
//   return current && current < moment().startOf("day");
// }

class App extends React.Component {

  state = {

    notificationTitle: "",
    notificationText: "",
    notificationMail: false,
    notificationApp: false,
    notificationSms: false,
    categoryOptions:[],
    name: "",
    description: "",
    message_text_count: 500,
    selectCategory:[]
  };

  componentDidMount() {
    this.loadEventCategories()
  }

  loadEventCategories() {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios_eventtag.get(apiConfig.EVENT_CATOGARIES, {headers: headers})
      .then(response => {
        if (response.data.success) {
          if (response.data.category.length !== 0) {
            const temp = [{text:'All',value:"ALL"}]
            response.data.category.map(item => {
              temp.push({text:item.title,value:item.event_category_id})
            })
            this.setState({ categoryOptions:temp })
          }
        }
        else {
          this.setState({ categoryOptions:[] })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  onHandleChangeNotificationCheckBox = (item) => {
    switch (item) {
      case "EMAIL":
        this.setState({notificationMail: !this.state.notificationMail});
        break;
      case "APP":
        this.setState({notificationApp: !this.state.notificationApp});
        break;
      case "SMS":
        this.setState({notificationSms: !this.state.notificationSms});
        break;
      default:
        break;
    }

  };

  onChangeAction = (event) =>{
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  onHandleChangeCategory = (e, {value}) => {

    if (value.includes("ALL")) {
      const temp = []
      this.state.categoryOptions.map(item => {
        if (item.value !== "ALL") {
          temp.push(item.value)
        }
      })
      this.setState({ selectCategory: temp })
    } else {
      this.setState({ selectCategory: value })
    }
  }

  validateNotification = () => {
    this.state.selectCategory.length === 0 ? common.notifyMessage("Please select category") : this.validateNotification_();
  };

  validateNotification_ = () => {
    this.state.name === "" ?
      common.notifyMessage("Please enter notification title") :
        this.state.description === "" ?
          common.notifyMessage("Please enter notification text") :
          !this.state.notificationMail && !this.state.notificationApp && !this.state.notificationSms ?
            common.notifyMessage("Please select notification media") : this.sendToBackEnd();
  }

  sendToBackEnd = () => {
    const {name,description, notificationMail, notificationApp, notificationSms, selectCategory} = this.state ;
    const obj = {
      "notification_title" : name,
      "notification_text" :description,
      "notification_mail" : notificationMail,
      "notification_app" : notificationApp,
      "notification_sms" : notificationSms,
      "categoryIdList" : selectCategory
    }

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios_eventtag.put(apiConfig.SEND_CATEGORY_NOTIFICATION({corporateId: corporateId}), obj, {headers: headers})
    .then(response => {
      if (response.data.success) {
        common.warningAlert("Notification sent successfully!", 0);
      }
      else {
        common.warningAlert(response.data.message, 1)
      }
      this.clearFeilds()
    })
    .catch(async error => {
      let result = await common.checkErrorResponse(error);
      if (result === 1) {
        this.sendToBackEnd()
      }
    })
    .finally(fin => {
      this.props.spinnerHandler(false);
    });
  };

  clearFeilds = () => {
    this.setState ({
      name: "",
      description: "",
      notificationMail: false,
      notificationApp: false,
      notificationSms: false,
      message_text_count: 500,
      selectCategory:[]
    })
  };


  render() {

    const {name, description, selectCategory, notificationMail, notificationApp, notificationSms, categoryOptions} = this.state

    return (
      <div className={"set-notification"}>
        <Row>
          <Col xs="12" lg={"6"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Filter Categories
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    <Col lg={12}>

                      <div>
                        <Form id={'category_filter_form'}>
                          <Form.Group widths='equal'>
                            <LabelDropdown
                              multiple={true}
                              required
                              className={"select-host"}
                              // loading={host_loader}
                              btnText={"Get Info"}
                              tagText={"Category"}
                              placeholder={"Select category"}
                              options={categoryOptions}
                              value={selectCategory}
                              // onSearchChange={this.handleSearchHost}
                              onChange={this.onHandleChangeCategory}
                            />
                          </Form.Group>
                        </Form>
                      </div>

                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
          <Col xs="12" lg={"6"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                Create Notifications
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    {/*<Col lg ={2}></Col>*/}
                    <Col lg={12}>
                      <Row>
                        <Col lg={12}>
                          <Form>
                            <Form.Group widths='equal'>
                              <TxtLbl
                                required
                                tagText={"Notification Title"}
                                placeholder={"Enter notification title"}
                                value={name}
                                name='name'
                                onChange={this.onChangeAction}
                              />
                            </Form.Group>
                            <Form.Group widths='equal'>
                              <TxtAreaLbl
                                required
                                maxLength={500}
                                tagText={"Notification Text"}
                                placeholder={"Enter notification text"}
                                value={description}
                                name='description'
                                onChange={this.onChangeAction}
                              />
                            </Form.Group>
                            <div className={'text-right'}><span>{500 - (description.length)}</span><span>/ 500</span></div>
                          </Form>
                        </Col>
                        <Col lg={6} md={6}>
                          <Lbl required>Notification Media</Lbl>
                          <Row className={""}>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={notificationMail}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("EMAIL")}
                              >
                                E-mail
                              </Checkbox>
                            </Col>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={notificationApp}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("APP")}
                              >
                                Mobile App
                              </Checkbox>
                            </Col>
                            <Col lg={12}>
                              <Checkbox
                                className={"mk-block"}
                                checked={notificationSms}
                                onChange={() =>this. onHandleChangeNotificationCheckBox("SMS")}
                              >
                                SMS
                              </Checkbox>
                            </Col>
                          </Row>
                        </Col>
                        <Col lg={12} md={12} className={"text-center"}>
                          <Button
                            className="yellow-btn mt-3"
                            style={{color: 'white'}}
                            onClick={this.validateNotification}
                          >Send</Button>
                        </Col>
                      </Row>
                    </Col>
                    {/*<Col lg ={2}></Col>*/}
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  test_alleventobject: state.eventReducer.allEventsObj,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
